import LoadingOverlay from "./components/LoadingOverlay";

const ProductTab = (props) => {
    // Handle both string (new format) and array (old cached format)
    const content =
        typeof props.data === "string" ? props.data : JSON.stringify(props.data, null, 2);

    return (
        <div
            className="flex w-full flex-col overflow-y-hidden"
            style={{
                margin: "0px",
                padding: "0px",
                overflowY: "hidden",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
            }}
        >
            {props.data ? (
                <>
                    <pre
                        className="ngShadow overflow-y-hidden whitespace-pre rounded bg-white p-4"
                        style={{
                            fontFamily:
                                "'Roboto Mono', 'SF Mono', 'Consolas', 'Liberation Mono', monospace",
                            fontStretch: "condensed",
                            fontSize: "9.5px",
                            // letterSpacing: "0.0px",
                            lineHeight: "1",
                        }}
                    >
                        {content}
                    </pre>
                    <p className="px-3 py-0.5 text-xs text-gray-400">
                        <strong>Data Source:</strong> matrixed-org-chart.txt | SuiteScripts &gt;
                        Netgain Customer Profile &gt; webapp &gt; product-teams-source-file |
                        Account: 57428
                    </p>
                </>
            ) : (
                <LoadingOverlay text="Loading matrixed org..." />
            )}
        </div>
    );
};

export default ProductTab;
